module.exports = __webpack_public_path__ + "img/eye_bolt.prt.e33f7654.jpg";